import { useAppDispatch } from '@/store'
import { computeOrdersNumberAfterRecurrenceUpsert } from '@/features/domain/order'

export async function checkCanAddOrders(
  orderRequest: uui.domain.ui.forms.BulkOrderUpdate,
  dispatch: ReturnType<typeof useAppDispatch>,
): Promise<boolean> {
  // no need to check if not a bulk update with recurrence settings change
  if (orderRequest.type === 'bulk') return true

  const checkCanAddOrdersRequest = await dispatch(
    computeOrdersNumberAfterRecurrenceUpsert([orderRequest]),
  )

  if (computeOrdersNumberAfterRecurrenceUpsert.fulfilled.match(checkCanAddOrdersRequest)) {
    return checkCanAddOrdersRequest.payload.canProceed
  }

  return false
}
